export default {
    sessao: 'CB8379AC2098AA165029E3938A51DA0BCECFC008FD6795F401178647F96C5B34'
}